import { render, staticRenderFns } from "./LabCalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=template&id=61fe50e4&"
import script from "./LabCalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=script&lang=ts&"
export * from "./LabCalorimetrySpecificHeatCapacityOfMetal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports